import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../theme";
import { getCountingStategyLabelData } from "../../../../utils/labelColorText";
import BaseCard from "../../../theme/cards/BaseCard";
import CardLabel from "../../../theme/label/CardLabel";
import TopRight from "../../../theme/positionals/TopRight";
import ShDoubleTextSkeleton from "../../../theme/skeleton/ShDoubleTextSkeleton";
import ShTextSkeleton from "../../../theme/skeleton/ShTextSkeleton";
import Text from "../../../theme/text/Text";

const SettingsWarehouseCountingStrategyCard = (props) => {
    const { t,i18n } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const {labeltext, labelcolor} = getCountingStategyLabelData(props.type,theme);
                


    return (
        <BaseCard onClick={props.skeleton ? null : props.onClick}>
            <Box>
                <Box >
                    <Box display={"flex"}
                        sx={{
                            gap:3,
                        }}
                    >
                        <Box
                            sx={{
                                minWidth:170,
                                display:"flex",
                                flexDirection:"column",
                                overflow:"hidden",
                                flex:1,
                            }}
                        >
                            {props.skeleton ? 
                                <ShDoubleTextSkeleton/> 
                                :
                                <>
                                    <Text noBreak bold>{props.name}</Text>
                                    <Text>{t(props.frequency)}</Text>
                                </>
                            }
                        </Box>
                        
                    </Box>

                    <TopRight>
                        <CardLabel 
                            variant={labelcolor}
                            fitted
                            position="child-tr"
                        >
                            {t(labeltext)}
                        </CardLabel>
                    </TopRight>

                    <Box mt={2}>
                        <Box
                            sx={{
                                display:"flex",
                                gap:1,
                            }}
                        >
                            <Text light>{t("amount")}</Text>
                            {props.skeleton ?
                                <ShTextSkeleton/>
                                :
                                <Text>{props.amount}%</Text>
                            }
                        </Box>
                    </Box>

                   
                    
                </Box>
            </Box>
        </BaseCard>
    )
}
export default SettingsWarehouseCountingStrategyCard;